/*
 * GLEAM PREMIUM — Microinteracciones + scroll reveal + live social proof
 * Carga solo en template product
 */

(function () {
  'use strict';

  if (!document.body.classList.contains('template-product')) return;

  /* ----------------------------------------
   * 1. SCROLL REVEAL — secciones aparecen con fade
   * ---------------------------------------- */
  const revealSelectors = [
    '.shopify-section .results-section',
    '.shopify-section .testimonials-section',
    '.shopify-section .collapsible-content',
    '.shopify-section .icon-bar-section',
    '.shopify-section [class*="image-with-text"]'
  ];

  const revealEls = document.querySelectorAll(revealSelectors.join(','));
  revealEls.forEach((el) => el.classList.add('gleam-reveal'));

  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -80px 0px', threshold: 0.05 }
    );
    revealEls.forEach((el) => io.observe(el));
  } else {
    revealEls.forEach((el) => el.classList.add('in-view'));
  }

  /* ----------------------------------------
   * 2. LIVE SOCIAL PROOF — número aleatorio realista
   * ---------------------------------------- */
  const liveProofEls = document.querySelectorAll('[data-gleam-live-proof]');
  if (liveProofEls.length) {
    const baseCount = 14 + Math.floor(Math.random() * 32);
    let current = baseCount;
    liveProofEls.forEach((el) => {
      const countEl = el.querySelector('.gleam-live-proof__count');
      if (countEl) countEl.textContent = current;
    });

    setInterval(() => {
      const delta = Math.random() > 0.5 ? 1 : -1;
      current = Math.max(8, Math.min(48, current + delta));
      liveProofEls.forEach((el) => {
        const countEl = el.querySelector('.gleam-live-proof__count');
        if (countEl) countEl.textContent = current;
      });
    }, 9000 + Math.random() * 5000);
  }

  /* ----------------------------------------
   * 3. STOCK COUNTDOWN — número que va bajando lento
   * ---------------------------------------- */
  const stockAlerts = document.querySelectorAll('.stock-alert strong');
  stockAlerts.forEach((el) => {
    let n = 6 + Math.floor(Math.random() * 8);
    el.textContent = `¡Solo quedan ${n} unidades!`;
    const tick = () => {
      if (n > 3 && Math.random() > 0.6) {
        n--;
        el.textContent = `¡Solo quedan ${n} unidades!`;
      }
    };
    setInterval(tick, 35000 + Math.random() * 25000);
  });

  /* ----------------------------------------
   * 4. SMOOTH SCROLL desde bullets/links a CTA
   * ---------------------------------------- */
  document.querySelectorAll('[data-scroll-to-buy]').forEach((el) => {
    el.addEventListener('click', (e) => {
      e.preventDefault();
      const buyBtn = document.querySelector('button[name="add"], .product-form__submit');
      if (buyBtn) {
        buyBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
        buyBtn.classList.add('gleam-pulse');
        setTimeout(() => buyBtn.classList.remove('gleam-pulse'), 1200);
      }
    });
  });

  /* ----------------------------------------
   * 5. CTA HOVER PULSE on first view
   * ---------------------------------------- */
  const buyBtns = document.querySelectorAll('button[name="add"], .product-form__submit');
  if (buyBtns.length && 'IntersectionObserver' in window) {
    const ioCta = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.animate(
              [
                { transform: 'scale(1)' },
                { transform: 'scale(1.04)' },
                { transform: 'scale(1)' }
              ],
              { duration: 700, easing: 'cubic-bezier(0.4, 0, 0.2, 1)' }
            );
            ioCta.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.6 }
    );
    buyBtns.forEach((b) => ioCta.observe(b));
  }

  /* ----------------------------------------
   * 6. ATC TOAST — feedback al añadir al carrito
   * ---------------------------------------- */
  const showToast = (msg) => {
    const existing = document.querySelector('.gleam-toast');
    if (existing) existing.remove();
    const toast = document.createElement('div');
    toast.className = 'gleam-toast';
    toast.textContent = msg;
    Object.assign(toast.style, {
      position: 'fixed',
      bottom: '90px',
      left: '50%',
      transform: 'translateX(-50%) translateY(20px)',
      background: 'linear-gradient(135deg, #00b67a, #00a06c)',
      color: '#fff',
      padding: '14px 22px',
      borderRadius: '14px',
      boxShadow: '0 8px 30px rgba(0,182,122,0.35)',
      fontWeight: '700',
      fontSize: '14px',
      letterSpacing: '0.02em',
      zIndex: '9999',
      opacity: '0',
      transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
      maxWidth: '90vw'
    });
    document.body.appendChild(toast);
    requestAnimationFrame(() => {
      toast.style.opacity = '1';
      toast.style.transform = 'translateX(-50%) translateY(0)';
    });
    setTimeout(() => {
      toast.style.opacity = '0';
      toast.style.transform = 'translateX(-50%) translateY(20px)';
      setTimeout(() => toast.remove(), 500);
    }, 2500);
  };

  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (form.matches('form[action*="/cart/add"]')) {
      setTimeout(() => showToast('✓ Producto agregado al carrito'), 200);
    }
  });

  /* ----------------------------------------
   * 7. KEYFRAME PULSE para CTAs scrolleados
   * ---------------------------------------- */
  const styleEl = document.createElement('style');
  styleEl.textContent = `
    .gleam-pulse {
      animation: gleamCtaPulse 0.6s cubic-bezier(0.4, 0, 0.2, 1) 2 !important;
    }
    @keyframes gleamCtaPulse {
      0%, 100% { transform: translateY(0) scale(1); }
      50% { transform: translateY(-4px) scale(1.03); }
    }
  `;
  document.head.appendChild(styleEl);
})();
